import type { KeyMetricsRevenueDTO } from "../models/keyMetricsRevenueDto";
import type { KeyMetricsRevenueEntity } from "../../domain/entities/KeyMetricsRevenueEntity";

export function keyMetricsRevenueDtoToEntity(
  dto: KeyMetricsRevenueDTO
): KeyMetricsRevenueEntity {
  return {
    ytdRevenue: Number(dto.ytdRevenue) || 0,
    ytdSubtext: String(dto.ytdSubtext ?? ""),
    collectionRateValue: Number(dto.collectionRateValue) || 0,
    collectionRateBadge: String(dto.collectionRateBadge ?? "Stable"),
    dsoAvgDays: Number(dto.dsoAvgDays) || 0,
    dsoChangeDays: Number(dto.dsoChangeDays) || 0,
    dsoChangeVariant:
      dto.dsoChangeVariant === "up" || dto.dsoChangeVariant === "down"
        ? dto.dsoChangeVariant
        : null,
    dsoStatus:
      dto.dsoStatus === "excellent" ||
      dto.dsoStatus === "healthy" ||
      dto.dsoStatus === "watch" ||
      dto.dsoStatus === "critical"
        ? dto.dsoStatus
        : "healthy",
    dsoStatusLabel: String(dto.dsoStatusLabel ?? "Healthy"),
    dsoWindowMonths:
      dto.dsoWindowMonths != null ? Number(dto.dsoWindowMonths) : undefined,
    dsoWindowLabel:
      dto.dsoWindowLabel != null ? String(dto.dsoWindowLabel) : undefined,
    currencySymbol: String(dto.currencySymbol ?? "₹"),
  };
}
